<template>
  <div>
    <Head :title="form.business_name" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/admin/perdoruesit/shitesit">Shitësit</Link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ form.first_name }} {{form.last_name}}
    </h1>
    <trashed-message v-if="seller.deleted_at" class="mb-6" @restore="restore"> Ky shitës është fshirë nga sistemi. </trashed-message>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">

        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <h1 class="text-xl font-bold pb-8 pr-6 w-full lg:w-full">Të dhënat e shitësit</h1>
          <text-input v-model="form.first_name" :error="form.errors.first_name" class="pb-8 pr-6 w-full lg:w-1/2" label="Emri" />
          <text-input v-model="form.last_name" :error="form.errors.last_name" class="pb-8 pr-6 w-full lg:w-1/2" label="Mbiemri" />
          <text-input v-model="form.email" :error="form.errors.email" class="pb-8 pr-6 w-full lg:w-1/2" label="Email" />
          <text-input v-model="form.phone" :error="form.errors.phone" class="pb-8 pr-6 w-full lg:w-1/2" label="Numri i telefonit" />
          <text-input v-model="form.second_phone" :error="form.errors.second_phone" class="pb-8 pr-6 w-full lg:w-1/2" label="Numri i telefonit(sekondar)" />
          <select-input v-model="form.reference_id" :error="form.errors.reference_id" class="pb-8 pr-6 w-full lg:w-1/2" label="Referenca">
            <option v-for="reference in references" :key="reference.id" :value="reference.id">{{ reference.name }}</option>
            <option :value="0">Tjetër</option>
          </select-input>
          <text-input v-if="reference_other_show" v-model="form.reference_other" ref="reference" :error="form.errors.reference_other" class="pb-8 pr-6 w-full lg:w-1/2" label="Referenca tjetër" />

          <select-input v-model="form.api_enabled" :error="form.errors.api_enabled" class="pb-8 pr-6 w-full lg:w-1/2" label="API">
            <option :value="false">Jo</option>
            <option :value="true">Po</option>
          </select-input>

        </div>

        <hr>

        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button v-if="user.role === 'superadmin' && !seller.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Fshij</button>
          <button v-if="user.role === 'superadmin' && seller.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="forceDelete">Fshij përgjithmonë</button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Edito</loading-button>
        </div>
      </form>
    </div>


    <div class="flex items-center mb-6">
      <h2 class="mt-12 text-2xl font-bold">Bizneset</h2>

      <Link class="btn-indigo mt-12 ml-6" :href="route('admin.users.sellers.businesses.create',{seller: seller.id})">
        <span>Regjistro</span>
        <span class="hidden md:inline"> Biznes të ri</span>
      </Link>
    </div>

    <div id="businesses" class="mt-6 bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-6">Emri i biznesit</th>
          <th class="pb-4 pt-6 px-6">Numri i biznesit</th>
          <th class="pb-4 pt-6 px-6">Telefoni i biznesit</th>
          <th class="pb-4 pt-6 px-6">Adresa (primare)</th>
          <th class="pb-4 pt-6 px-6">Qyteti (primar)</th>
          <th class="pb-4 pt-6 px-6">Regjioni (primar)</th>
          <th class="pb-4 pt-6 px-6">Krijuar më</th>
          <th class="pb-4 pt-6 px-6">Edituar më</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="business in seller.businesses.data" :key="business.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/admin/bizneset/${business.id}/edit`">
              {{ business.name }}
              <icon v-if="business.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
              <icon v-if="business.primary" name="primary" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />

            </Link>
          </td>

          <td class="border-t">
            <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/admin/bizneset/${business.id}/edit`">
              {{ business.number }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/admin/bizneset/${business.id}/edit`">
              {{ business.phone }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/admin/bizneset/${business.id}/edit`">
              {{ business.location !=null ? business.location.address : null}}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/admin/bizneset/${business.id}/edit`">
              {{ business.location !=null ? business.location.city.name : null}}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/admin/bizneset/${business.id}/edit`">
              {{ business.location !=null ? business.location.region.name : null}}
            </Link>
          </td>

          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/admin/bizneset/${business.id}/edit`" tabindex="-1">
              {{ business.hr_created_at }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/admin/bizneset/${business.id}/edit`" tabindex="-1">
              {{ business.hr_updated_at }}
            </Link>
          </td>
          <td class="w-px border-t">
            <Link class="flex items-center px-4" :href="`/admin/bizneset/${business.id}/edit`" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </Link>
          </td>
        </tr>
        <tr v-if="seller.businesses.data.length === 0">
          <td class="px-6 py-4 border-t" colspan="4">Nuk u gjet asnje biznes.</td>
        </tr>
        </tbody>
      </table>
    </div>

    <div v-if="user.role === 'superadmin'" class="max-w-3xl mt-10 bg-white rounded-md shadow overflow-hidden">
      <form id="updatePassword" @submit.prevent="updatePassword">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input type="password" v-model="updatePasswordForm.new_password" :error="updatePasswordForm.errors.new_password" class="pb-8 pr-6 w-full lg:w-full" label="Fjalëkalimi i ri"  />
          <text-input type="password" v-model="updatePasswordForm.new_confirm_password" :error="updatePasswordForm.errors.new_confirm_password" class="pb-8 pr-6 w-full lg:w-full" label="Konfirmo fjalëkalimin e ri"/>


        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="updatePasswordForm.processing" class="btn-indigo ml-auto" type="button" @click="updatePassword">Ndrysho fjalëkalimin</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import {Head, Link, usePage} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import {computed} from 'vue'
import TrashedMessage from '@/Shared/TrashedMessage'
import Icon from '@/Shared/Icon'


export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
    Icon
  },
  layout: Layout,
  props: {
    references: Array,
    seller: Object
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        id: this.seller.id,
        first_name: this.seller.first_name,
        last_name: this.seller.last_name,
        email: this.seller.email,
        phone: this.seller.phone,
        second_phone: this.seller.second_phone,
        reference_id: this.seller.reference_id,
        reference_other: this.seller.reference_other,
        api_enabled: this.seller.api_enabled
      }),
      updatePasswordForm: this.$inertia.form({
        new_password: null,
        new_confirm_password: null
      }),
      reference_other_show: this.seller.reference_id === 0,
    }
  },
  methods: {
    update() {
      this.form.put(`/admin/perdoruesit/shitesit/${this.seller.id}`)
    },
    destroy() {
      if (confirm('A jeni të sigurt?')) {
        this.$inertia.delete(`/admin/perdoruesit/shitesit/${this.seller.id}`)
      }
    },
    restore() {
      if (confirm('A jeni të sigurt?')) {
        this.$inertia.put(`/admin/perdoruesit/shitesit/${this.seller.id}/restore`)
      }
    },
    forceDelete() {
      if (confirm('Ky veprim është i pakthyeshëm, shitësi nuk mund të kthehet më pas këtij veprimi. A jeni të sigurt se me të vërtetë dëshironi ta fshini këtë shitës?')) {
        this.$inertia.put(`/admin/perdoruesit/shitesit/${this.seller.id}/forceDestroy`)
      }
    },
    updatePassword(){
      this.updatePasswordForm.put(`/admin/perdoruesit/password/${this.seller.id}`)
    }
  },
  watch: {
    'form.reference_id'(newValue){
      this.reference_other_show = newValue === 0;
    }
  },
  setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return {user}
  },
}
</script>
